import { render, staticRenderFns } from "./LazyNode.vue?vue&type=template&id=5fd81086&scoped=true&"
import script from "./LazyNode.vue?vue&type=script&lang=js&"
export * from "./LazyNode.vue?vue&type=script&lang=js&"
import style0 from "./LazyNode.vue?vue&type=style&index=0&id=5fd81086&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd81086",
  null
  
)

export default component.exports